import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { RoundCard, RunnerUpHeader, TabList } from "../../../ui";
import { tabs } from "./Tabs/Tabs";
// import { useGetEpbpinQuery } from '../../../services/api';
import GeneralElectionToAssemblyConstituency from "./Tabs/GeneralElection_to_AssemblyConstituency";
import { Link } from "react-router-dom";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const EpbPinDownload = () => {
 
  const [defaultKey,setDefaultKey]=useState(1)
  const renderTabs = () => {
    switch (defaultKey) {
        case "1":
            return <GeneralElectionToAssemblyConstituency  constType={"AC"} electType={"GEN"}/>
        case "2":
            return <GeneralElectionToAssemblyConstituency  constType={"PC"} electType={"GEN"}/>
        case "3":
            return <GeneralElectionToAssemblyConstituency  constType={"AC"} electType={"BYE"}/>
        case "4":
            return <GeneralElectionToAssemblyConstituency  constType={"PC"} electType={"BYE"}/>
         default:
                return <GeneralElectionToAssemblyConstituency constType={"AC"} electType={"GEN"} />
      
    }
}

  return (
   <LeftMenu>
     <div className="ep-download">
      <div className="container box shadow ">
        <RunnerUpHeaderNew title={"e-PB PIN Download"} />
        <Tabs
          id="uncontrolled-tab-example"
          className="mb-3 tab-list"
          activeKey={defaultKey}
          onSelect={(k) => setDefaultKey(k)}
        >
          {tabs.map((item) => (
            <Tab eventKey={item.key} title={item.label} >
              {}
            </Tab>
          ))}
        </Tabs>
        {renderTabs()}
      </div>
    </div>
   </LeftMenu>
  );
};

export default EpbPinDownload;
